import { Container, ContainerProps, useTheme } from "@mui/material";

type PageLayoutProps = {
  children: React.ReactNode;
} & ContainerProps;

const PageLayout: React.FC<PageLayoutProps> = (props) => {
  const { children, maxWidth = "xl", sx, ...rest } = props;
  const theme = useTheme();

  return (
    <Container
      maxWidth={maxWidth}
      sx={{
        pb: 1,
        [theme.breakpoints.down("lg")]: {
          px: 1,
        },
        [theme.breakpoints.down("sm")]: {
          px: 0,
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Container>
  );
};

export default PageLayout;
